import * as React from "react";
import ProductCompareClearAll from "../../../../component/Product/ProductCompareClearAll";
import { useSelector } from "react-redux";
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";

const AddClearbtn = (props) => {
  const list = useSelector((state) => state.entities.model_ProductCompare.data);
  const [__check] = useAxiosIndicatorCheck();

  /**
   * author : tusharKc
   * changes: using history.back(), to dynamically route the user
   * to the previous route,  instead of the static plp route
   * ticket: 9077
   *
   */

  /**
   * 
   * author: tusharKc
   * ticket: 9097
   * change: adding condition on showing the add part button
   */

  return (
    <>
      <div className="add-clear-btn">
        {Object.entries(list).length < 10 && (
          <button
            className="bs5 btn btn-secondary m-1"
            disabled={window?.parent?.navigation?.canGoBack === false}
            onClick={() => {
              history.back();
            }}
          >
            ADD PART
          </button>
        )}
        {Object.entries(list).length > 0 && (
          <ProductCompareClearAll type="button" />
        )}
        <a href={void 0} className="compare-clear-link">
          {
            __check(
              [
                "PRODUCT_COMPARE_API_CALL",
                "PRODUCT_INVENTORY_API_CALL",
                "CART_API_CALL",
                "PRODUCT_PRICING_API_CALL",
              ],
              { inline: true }
            ).render
          }
        </a>
      </div>
    </>
  );
};

export default AddClearbtn;
